import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ButtonCustom from '../UI/ButtonCustom.vue';
    import { ref, computed } from 'vue';
    import { API } from "@/api/modules/cart";
    import handleError from '@/tools/errorHandler'
    import { useNotification } from "@kyvg/vue3-notification";
    import { useStore } from 'vuex'
    interface IProps{
        product_id:number
        price_id:number | null
        dops:Array<number>
        amount :number
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PushProduct',
  props: {
    product_id: {},
    price_id: {},
    dops: {},
    amount: {}
  },
  emits: ['toCart'],
  setup(__props: any, { emit }) {

const props = __props;

    const { notify }  = useNotification()

    const store = useStore()

    let token = computed(()=>{
        return store.getters.token
    })


    
    let buttonText = ref('В корзину')


    
    

    function addToCart(){
        if(token.value == null){
            notify({
                group: 'notification',
                title: `Вы не авторизированы!`,
                text: `
                    Чтобы создать заказ нужно авторизоватться
                `,
                type: "warn",
                duration: 500,
                closeOnClick: true,
            });
            return
        }
        if(props.price_id == null){
            notify({
                group: 'notification',
                title: `Не коректный товар`,
                text: `
                    Выбери все тыкалки<br/>
                `,
                type: "warn",
                duration: 500,
                closeOnClick: true,
            });
            return
        }
        emit('toCart')
        API
            .addToCart(props.product_id, props.price_id, props.dops, props.amount, token.value)
            .then(() => {
                emit('toCart') 
                notify({
                    group: 'notification',
                    title: `Товар помещен в корзину`,
                    text: `
                        
                    `,
                    type: "succ",
                    duration: 500,
                    closeOnClick: true,
                });
            })
            .catch((err) => handleError(err))
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ButtonCustom, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addToCart()))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
      ]),
      _: 1
    })
  ]))
}
}

})